import { bl_fi_deposit_requisition_hdr_entity_attachment_RowClass } from '../../dbschema/bl_fi_deposit_requisition_hdr_entity_attachment.model';
import { BaseContainerModel } from '../base-container.model';

export class DepositRequisitionEntityAttachmentContainerModel extends BaseContainerModel {
  bl_fi_deposit_requisition_hdr_entity_attachment: bl_fi_deposit_requisition_hdr_entity_attachment_RowClass = new bl_fi_deposit_requisition_hdr_entity_attachment_RowClass();
}
